import Cookies from 'js-cookie';

const CLIENT_UUID_COOKIE = 'clientUuid';

export function getClientUuid(): string {
  return Cookies.get(CLIENT_UUID_COOKIE) ?? '';
}
